export const comments_3296370 = {"data":{"data":[],"links":{}}}